import {
  faBell,
  faBolt,
  faCircleExclamation,
  faCrown,
  faFire,
  faFlag,
  faGem,
  faHeart,
  faStar,
  faThumbtack,
  IconDefinition,
} from "@fortawesome/pro-duotone-svg-icons";
import { LeadIcon } from "enums/lead-icon.enum";
import { TSelectOption } from "types/select-input.type";
import { TLeadIconConfig } from "types/lead-icon.type";

export const LEAD_ICON_MAP: Record<
  LeadIcon,
  { icon: IconDefinition; color: string }
> = {
  [LeadIcon.Fire]: { icon: faFire, color: "red.500" },
  [LeadIcon.Star]: { icon: faStar, color: "yellow.400" },
  [LeadIcon.Bolt]: { icon: faBolt, color: "orange.400" },
  [LeadIcon.Flag]: { icon: faFlag, color: "red.400" },
  [LeadIcon.Heart]: { icon: faHeart, color: "pink.500" },
  [LeadIcon.Crown]: { icon: faCrown, color: "yellow.500" },
  [LeadIcon.Gem]: { icon: faGem, color: "teal.400" },
  [LeadIcon.Bell]: { icon: faBell, color: "blue.400" },
  [LeadIcon.CircleExclamation]: {
    icon: faCircleExclamation,
    color: "orange.500",
  },
  [LeadIcon.Thumbtack]: { icon: faThumbtack, color: "purple.400" },
};

export const LEAD_ICON_LABELS: Record<LeadIcon, string> = {
  [LeadIcon.Fire]: "Fire",
  [LeadIcon.Star]: "Star",
  [LeadIcon.Bolt]: "Lightning",
  [LeadIcon.Flag]: "Flag",
  [LeadIcon.Heart]: "Heart",
  [LeadIcon.Crown]: "Crown",
  [LeadIcon.Gem]: "Gem",
  [LeadIcon.Bell]: "Bell",
  [LeadIcon.CircleExclamation]: "Alert",
  [LeadIcon.Thumbtack]: "Pin",
};

export const LEAD_ICON_OPTIONS: TSelectOption<LeadIcon>[] = Object.values(
  LeadIcon
).map(value => ({
  value,
  label: LEAD_ICON_LABELS[value],
}));

export const DEFAULT_LEAD_ICONS: Record<string, LeadIcon> = {
  rightmove_valuation: LeadIcon.Fire,
};

const normalizeLeadIconMatchValue = (value: string): string =>
  value.trim().toLowerCase();

export const getLeadIconKey = (source: string, type: string): string =>
  `${normalizeLeadIconMatchValue(source)}|${normalizeLeadIconMatchValue(type)}`;

export const getLeadIcon = (
  configMap: Record<string, TLeadIconConfig>,
  source: string,
  type: string
): LeadIcon | null => {
  if (!source || !type) return null;
  const configured = configMap[getLeadIconKey(source, type)];
  if (configured) return configured.icon;
  return DEFAULT_LEAD_ICONS[normalizeLeadIconMatchValue(source)] || null;
};
